import React from "react";

const DayBox = ({ days, handleDayClick, isDayClicked }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {days?.map((d) => (
        <div
          key={d}
          className={`w-[42px] h-[42px] sm:w-[50px] sm:h-[50px] md:w-[60px] md:h-[60px] border-[1.5px] rounded-[10px] bg-white ${isDayClicked(d) ? "border-[#00ADEF]" : "border-[#D9D9D9]"
            } flex justify-center items-center font-poppins text-[12px] sm:text-[14px] font-[400] text-[#303030] cursor-pointer transition-all hover:border-[#00ADEF]`}
          onClick={() => {
            handleDayClick(d);
          }}
        >
          {d.slice(0, 3)}
        </div>
      ))}
    </div>
  );
};

export default DayBox;
